unit View.Codigo_bc_Piscofins.List;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, Math,

  WEBLib.StdCtrls, Web, JS, WEBLib.Lists,

  App.Types, WEBLib.Controls, WEBLib.Grids, Data.DB,
  XData.Web.Dataset, WEBLib.DBCtrls, WEBLib.DB, WEBLib.ExtCtrls,

  XData.Web.JsonDataset,

  Grid.Plugins,
  Crud.Utils, UUtils;

type
  TFViewCodigo_bc_PiscofinsList = class(TForm)
    btNew: TButton;
    Codigo_bc_PiscofinsDataset: TXDataWebDataSet;
    Codigo_bc_PiscofinsDatasetcodigo_bc_piscofins_id: TIntegerField;
    Codigo_bc_PiscofinsDatasetnome: TStringField;
    Codigo_bc_PiscofinsDatasetexcluido: TBooleanField;
    Codigo_bc_PiscofinsDatasetinclusao: TDateTimeField;
    Codigo_bc_PiscofinsDatasetalteracao: TDateTimeField;
    Codigo_bc_PiscofinsDatasetexclusao: TDateTimeField;
    WebDBTableControl1: TDBTableControl;
    WebDataSource: TDataSource;
    cbPageSize: TComboBox;
    edSearch: TEdit;
    lbPaginationInfo: TLabel;
    lcPaginator: TListControl;
    procedure WebFormCreate(Sender: TObject);
    procedure btNewClick(Sender: TObject);
    procedure WebDBTableControl1GetCellChildren(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure cbPageSizeChange(Sender: TObject);
    procedure edSearchChange(Sender: TObject);
  private
    FEditProc: TEditProc;
    FGridPlugin: TGridPlugin;
  public
    class function CreateForm(AElementID: string; AShowEditProc: TEditProc): TForm;
  protected procedure LoadDFMValues; override; end;

var
  FViewCodigo_bc_PiscofinsList: TFViewCodigo_bc_PiscofinsList;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewCodigo_bc_PiscofinsList }

procedure TFViewCodigo_bc_PiscofinsList.cbPageSizeChange(Sender: TObject);
begin
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text), True);
end;

class function TFViewCodigo_bc_PiscofinsList.CreateForm(AElementID: string;
  AShowEditProc: TEditProc): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewCodigo_bc_PiscofinsList(AForm).FEditProc := AShowEditProc;
  end;

begin
  Application.CreateForm(TFViewCodigo_bc_PiscofinsList, AElementID, Result, @AfterCreate);
end;

procedure TFViewCodigo_bc_PiscofinsList.edSearchChange(Sender: TObject);
begin
  FGridPlugin.SetFilterText(edSearch.Text, True);
end;

procedure TFViewCodigo_bc_PiscofinsList.btNewClick(Sender: TObject);
begin
  FEditProc( nil );
end;

procedure TFViewCodigo_bc_PiscofinsList.WebDBTableControl1GetCellChildren(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordId: JSValue;

  procedure EditButtonClick(Sender: TObject);
  begin
    FEditProc(RecordId);
  end;

var
  Button: TButton;
begin
  if ARow = 0 then
    Exit;

  if WebDBTableControl1.Columns[ACol].Title = 'Actions' then
  begin
    RecordId := TCrudUtils.GetIdFromObject(
      Codigo_bc_PiscofinsDataset.Connection.Model.DefaultSchema.FindEntityType(Codigo_bc_PiscofinsDataset.EntitySetName),
      Codigo_bc_PiscofinsDataset.CurrentData
    );
    Button := TButton.Create(nil);
    Button.Caption := 'Edit';
    Button.OnClick := @EditButtonClick;
    Button.ElementClassName := 'btn btn-outline btn-default btn-xs';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
  end;
end;

procedure TFViewCodigo_bc_PiscofinsList.WebFormCreate(Sender: TObject);
begin
  TUtils.SetValorDicionarioClasses('codigo_bc_piscofins', 'active');
  TUtils.SetValorDicionarioClasses('tributacoes_collapse', 'show');
  TUtils.SetValorDicionarioClasses('menu_tributacoes', 'active');
  TUtils.SetPaginaSelecionada;

  FGridPlugin := TGridPlugin.Create(
    WebDBTableControl1,
    Codigo_bc_PiscofinsDataset,
    lcPaginator,
    lbPaginationInfo
  );
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text));
  FGridPlugin.SetFilterText(edSearch.Text);
  FGridPlugin.Load;
end;

procedure TFViewCodigo_bc_PiscofinsList.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbPaginationInfo := TLabel.Create('view.codigo_bc_piscofins.list.pagination.info');
  btNew := TButton.Create('view.codigo_bc_piscofins.list.newbutton');
  WebDBTableControl1 := TDBTableControl.Create('view.codigo_bc_piscofins.list.table');
  cbPageSize := TComboBox.Create('view.codigo_bc_piscofins.list.cbPageSize');
  edSearch := TEdit.Create('view.codigo_bc_piscofins.list.search');
  lcPaginator := TListControl.Create('view.codigo_bc_piscofins.list.pagination');
  Codigo_bc_PiscofinsDataset := TXDataWebDataSet.Create(Self);
  Codigo_bc_PiscofinsDatasetcodigo_bc_piscofins_id := TIntegerField.Create(Self);
  Codigo_bc_PiscofinsDatasetnome := TStringField.Create(Self);
  Codigo_bc_PiscofinsDatasetexcluido := TBooleanField.Create(Self);
  Codigo_bc_PiscofinsDatasetinclusao := TDateTimeField.Create(Self);
  Codigo_bc_PiscofinsDatasetalteracao := TDateTimeField.Create(Self);
  Codigo_bc_PiscofinsDatasetexclusao := TDateTimeField.Create(Self);
  WebDataSource := TDataSource.Create(Self);

  lbPaginationInfo.BeforeLoadDFMValues;
  btNew.BeforeLoadDFMValues;
  WebDBTableControl1.BeforeLoadDFMValues;
  cbPageSize.BeforeLoadDFMValues;
  edSearch.BeforeLoadDFMValues;
  lcPaginator.BeforeLoadDFMValues;
  Codigo_bc_PiscofinsDataset.BeforeLoadDFMValues;
  Codigo_bc_PiscofinsDatasetcodigo_bc_piscofins_id.BeforeLoadDFMValues;
  Codigo_bc_PiscofinsDatasetnome.BeforeLoadDFMValues;
  Codigo_bc_PiscofinsDatasetexcluido.BeforeLoadDFMValues;
  Codigo_bc_PiscofinsDatasetinclusao.BeforeLoadDFMValues;
  Codigo_bc_PiscofinsDatasetalteracao.BeforeLoadDFMValues;
  Codigo_bc_PiscofinsDatasetexclusao.BeforeLoadDFMValues;
  WebDataSource.BeforeLoadDFMValues;
  try
    Name := 'FViewCodigo_bc_PiscofinsList';
    Width := 695;
    Height := 500;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    lbPaginationInfo.SetParentComponent(Self);
    lbPaginationInfo.Name := 'lbPaginationInfo';
    lbPaginationInfo.Left := 8;
    lbPaginationInfo.Top := 376;
    lbPaginationInfo.Width := 141;
    lbPaginationInfo.Height := 13;
    lbPaginationInfo.Caption := 'Showing 1 to 10 of 57 entries';
    lbPaginationInfo.HeightPercent := 100.000000000000000000;
    lbPaginationInfo.WidthPercent := 100.000000000000000000;
    btNew.SetParentComponent(Self);
    btNew.Name := 'btNew';
    btNew.Left := 8;
    btNew.Top := 8;
    btNew.Width := 50;
    btNew.Height := 25;
    btNew.Caption := 'New';
    btNew.HeightPercent := 100.000000000000000000;
    btNew.WidthPercent := 100.000000000000000000;
    SetEvent(btNew, Self, 'OnClick', 'btNewClick');
    WebDBTableControl1.SetParentComponent(Self);
    WebDBTableControl1.Name := 'WebDBTableControl1';
    WebDBTableControl1.Left := 8;
    WebDBTableControl1.Top := 94;
    WebDBTableControl1.Width := 521;
    WebDBTableControl1.Height := 265;
    WebDBTableControl1.ElementClassName := 'table-responsive';
    WebDBTableControl1.BorderColor := clSilver;
    WebDBTableControl1.ColHeader := False;
    WebDBTableControl1.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(WebDBTableControl1, Self, 'OnGetCellChildren', 'WebDBTableControl1GetCellChildren');
    WebDBTableControl1.Columns.Clear;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'codigo_bc_piscofins_id';
      Title := 'codigo_bc_piscofins_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'nome';
      Title := 'nome';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'excluido';
      Title := 'excluido';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'inclusao';
      Title := 'inclusao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'alteracao';
      Title := 'alteracao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'exclusao';
      Title := 'exclusao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      Title := 'Actions';
    end;
    WebDBTableControl1.DataSource := WebDataSource;
    cbPageSize.SetParentComponent(Self);
    cbPageSize.Name := 'cbPageSize';
    cbPageSize.Left := 8;
    cbPageSize.Top := 67;
    cbPageSize.Width := 81;
    cbPageSize.Height := 21;
    cbPageSize.HeightPercent := 100.000000000000000000;
    cbPageSize.TabOrder := 2;
    cbPageSize.Text := '10';
    cbPageSize.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSize, Self, 'OnChange', 'cbPageSizeChange');
    cbPageSize.ItemIndex := 0;
    cbPageSize.Items.BeginUpdate;
    try
      cbPageSize.Items.Clear;
      cbPageSize.Items.Add('10');
      cbPageSize.Items.Add('25');
      cbPageSize.Items.Add('50');
      cbPageSize.Items.Add('100');
    finally
      cbPageSize.Items.EndUpdate;
    end;
    edSearch.SetParentComponent(Self);
    edSearch.Name := 'edSearch';
    edSearch.Left := 408;
    edSearch.Top := 67;
    edSearch.Width := 121;
    edSearch.Height := 21;
    edSearch.HeightPercent := 100.000000000000000000;
    edSearch.TabOrder := 3;
    edSearch.WidthPercent := 100.000000000000000000;
    SetEvent(edSearch, Self, 'OnChange', 'edSearchChange');
    lcPaginator.SetParentComponent(Self);
    lcPaginator.Name := 'lcPaginator';
    lcPaginator.Left := 240;
    lcPaginator.Top := 365;
    lcPaginator.Width := 289;
    lcPaginator.Height := 25;
    lcPaginator.HeightPercent := 100.000000000000000000;
    lcPaginator.WidthPercent := 100.000000000000000000;
    lcPaginator.DefaultItemClassName := 'page-item';
    lcPaginator.DefaultItemLinkClassName := 'page-link';
    lcPaginator.ElementListClassName := 'pagination';
    lcPaginator.Style := lsPagination;
    Codigo_bc_PiscofinsDataset.SetParentComponent(Self);
    Codigo_bc_PiscofinsDataset.Name := 'Codigo_bc_PiscofinsDataset';
    Codigo_bc_PiscofinsDataset.EntitySetName := 'Codigo_bc_Piscofins';
    Codigo_bc_PiscofinsDataset.Connection := DMConnection.ApiConnection;
    Codigo_bc_PiscofinsDataset.Left := 72;
    Codigo_bc_PiscofinsDataset.Top := 144;
    Codigo_bc_PiscofinsDatasetcodigo_bc_piscofins_id.SetParentComponent(Codigo_bc_PiscofinsDataset);
    Codigo_bc_PiscofinsDatasetcodigo_bc_piscofins_id.Name := 'Codigo_bc_PiscofinsDatasetcodigo_bc_piscofins_id';
    Codigo_bc_PiscofinsDatasetcodigo_bc_piscofins_id.FieldName := 'codigo_bc_piscofins_id';
    Codigo_bc_PiscofinsDatasetcodigo_bc_piscofins_id.Required := True;
    Codigo_bc_PiscofinsDatasetnome.SetParentComponent(Codigo_bc_PiscofinsDataset);
    Codigo_bc_PiscofinsDatasetnome.Name := 'Codigo_bc_PiscofinsDatasetnome';
    Codigo_bc_PiscofinsDatasetnome.FieldName := 'nome';
    Codigo_bc_PiscofinsDatasetnome.Required := True;
    Codigo_bc_PiscofinsDatasetnome.Size := 255;
    Codigo_bc_PiscofinsDatasetexcluido.SetParentComponent(Codigo_bc_PiscofinsDataset);
    Codigo_bc_PiscofinsDatasetexcluido.Name := 'Codigo_bc_PiscofinsDatasetexcluido';
    Codigo_bc_PiscofinsDatasetexcluido.FieldName := 'excluido';
    Codigo_bc_PiscofinsDatasetinclusao.SetParentComponent(Codigo_bc_PiscofinsDataset);
    Codigo_bc_PiscofinsDatasetinclusao.Name := 'Codigo_bc_PiscofinsDatasetinclusao';
    Codigo_bc_PiscofinsDatasetinclusao.FieldName := 'inclusao';
    Codigo_bc_PiscofinsDatasetalteracao.SetParentComponent(Codigo_bc_PiscofinsDataset);
    Codigo_bc_PiscofinsDatasetalteracao.Name := 'Codigo_bc_PiscofinsDatasetalteracao';
    Codigo_bc_PiscofinsDatasetalteracao.FieldName := 'alteracao';
    Codigo_bc_PiscofinsDatasetexclusao.SetParentComponent(Codigo_bc_PiscofinsDataset);
    Codigo_bc_PiscofinsDatasetexclusao.Name := 'Codigo_bc_PiscofinsDatasetexclusao';
    Codigo_bc_PiscofinsDatasetexclusao.FieldName := 'exclusao';
    WebDataSource.SetParentComponent(Self);
    WebDataSource.Name := 'WebDataSource';
    WebDataSource.DataSet := Codigo_bc_PiscofinsDataset;
    WebDataSource.Left := 72;
    WebDataSource.Top := 200;
  finally
    lbPaginationInfo.AfterLoadDFMValues;
    btNew.AfterLoadDFMValues;
    WebDBTableControl1.AfterLoadDFMValues;
    cbPageSize.AfterLoadDFMValues;
    edSearch.AfterLoadDFMValues;
    lcPaginator.AfterLoadDFMValues;
    Codigo_bc_PiscofinsDataset.AfterLoadDFMValues;
    Codigo_bc_PiscofinsDatasetcodigo_bc_piscofins_id.AfterLoadDFMValues;
    Codigo_bc_PiscofinsDatasetnome.AfterLoadDFMValues;
    Codigo_bc_PiscofinsDatasetexcluido.AfterLoadDFMValues;
    Codigo_bc_PiscofinsDatasetinclusao.AfterLoadDFMValues;
    Codigo_bc_PiscofinsDatasetalteracao.AfterLoadDFMValues;
    Codigo_bc_PiscofinsDatasetexclusao.AfterLoadDFMValues;
    WebDataSource.AfterLoadDFMValues;
  end;
end;

end.
